/**
 * @file usePageTitles.ts
 * @description Названия страниц сайта по id — для списков изменений вида
 * сайта (phase19.28 этап А; дефект QA D-D7): «Страница «Условия доставки и
 * оплаты»: — → «Доставка и оплата»» вместо сырого id.
 *
 * Список страниц (`GET /admin/site/pages`) читается только когда в списке
 * изменений есть поле-ссылка на страницу, и один раз на открытие экрана
 * (общее обещание в модуле, сбрасывается после ответа: следующее открытие
 * окна увидит переименование). Сбой — показываем то, что пришло.
 */

import { useEffect, useState } from "react";

import { sitePages } from "../../lib/api-site-pages";

/** Поле изменения хранит id страницы: `brand.deliveryTermsPageId` и подобные. */
export const PAGE_ID_PATH = /PageId$/;

let pending: Promise<ReadonlyMap<string, string>> | null = null;

function loadTitles(): Promise<ReadonlyMap<string, string>> {
  pending ??= sitePages
    .list()
    .then((list) => new Map(list.map((page) => [page.id, page.title] as const)))
    .catch(() => new Map<string, string>())
    .finally(() => {
      pending = null;
    });
  return pending;
}

/** id → название страницы; `enabled: false` — не грузим. */
export function usePageTitles(enabled: boolean): ReadonlyMap<string, string> {
  const [titles, setTitles] = useState<ReadonlyMap<string, string>>(() => new Map());
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    void loadTitles().then((map) => {
      if (alive) setTitles(map);
    });
    return () => {
      alive = false;
    };
  }, [enabled]);
  return titles;
}
